export const APP_CHART = {
  brand: 'rgb(var(--color-app-brand))',
  accent: 'rgb(var(--color-app-accent))',
  positive: 'rgb(var(--color-app-positive))',
  warning: 'rgb(var(--color-app-warning))',
  critical: 'rgb(var(--color-app-critical))',
  focus: 'rgb(var(--color-app-focus))',
  ink: 'rgb(var(--color-app-ink))',
  muted: 'rgb(var(--color-app-muted))',
  line: 'rgb(var(--color-app-line))',
  surface: 'rgb(var(--color-app-surface-raised))',
} as const;

export const APP_CHART_SEQUENCE = [
  APP_CHART.brand,
  APP_CHART.focus,
  APP_CHART.accent,
  APP_CHART.positive,
  APP_CHART.warning,
  APP_CHART.critical,
  APP_CHART.muted,
] as const;

export function healthChartColour(score: number): string {
  if (score < 40) return APP_CHART.critical;
  if (score < 70) return APP_CHART.warning;
  return APP_CHART.positive;
}
